"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _closebtn = _interopRequireDefault(require("../assets/closebtn.png"));

var _closebtnDark = _interopRequireDefault(require("../assets/closebtnDark.png"));

var _NoFormInputs = _interopRequireDefault(require("./NoFormInputs"));

var FormInputs = function FormInputs(props) {
  var isSubmitting = props.isSubmitting,
      isSuccess = props.isSuccess,
      updateFormFields = props.updateFormFields,
      submitForm = props.submitForm,
      closeEmailCapture = props.closeEmailCapture,
      type = props.type,
      headerText = props.headerText,
      subheaderText = props.subheaderText,
      description = props.description,
      descriptionTextColor = props.descriptionTextColor,
      button = props.button,
      fields = props.fields,
      textColor = props.textColor,
      bgColor = props.bgColor,
      image = props.image,
      errors = props.errors,
      darkCloseBtn = props.darkCloseBtn;
  var displayCloseBtn = type === 'modal' && (!image || image.placement === 'left');
  var setBgColorStyle = {};

  if (image && image.placement !== 'background' || !image) {
    setBgColorStyle = {
      backgroundColor: bgColor
    };
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "emailcapture-form",
    style: setBgColorStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "emailcapture-form-subheader-close-wrapper"
  }, displayCloseBtn && /*#__PURE__*/_react["default"].createElement("div", {
    id: "closeEmailCaptureSpacer"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "emailcapture-form-subheader",
    style: {
      color: textColor
    }
  }, subheaderText), displayCloseBtn && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    as: "a",
    id: "closeEmailCapture",
    src: darkCloseBtn ? _closebtnDark["default"] : _closebtn["default"],
    onClick: closeEmailCapture
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    className: "emailcapture-form-header",
    style: {
      color: textColor
    }
  }, headerText), /*#__PURE__*/_react["default"].createElement("p", {
    className: "emailcapture-form-description",
    style: {
      color: descriptionTextColor
    }
  }, description), isSuccess && /*#__PURE__*/_react["default"].createElement(_NoFormInputs["default"], null), !isSuccess && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fields.map(function (field, key) {
    var errorMsg = errors[field.key];
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
      key: field.label,
      error: errorMsg,
      className: "emailcapture-form-input",
      placeholder: field.label,
      onChange: function onChange(event) {
        return updateFormFields(field.key, event);
      },
      value: field.value
    }), errorMsg && /*#__PURE__*/_react["default"].createElement("p", {
      className: "emailcapture-form-input-error",
      style: {
        color: descriptionTextColor
      }
    }, errorMsg));
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    loading: isSubmitting,
    onClick: submitForm,
    className: "emailcapture-form-button",
    style: {
      backgroundColor: button.bgColor,
      color: button.textColor
    }
  }, button.label)));
};

var _default = FormInputs;
exports["default"] = _default;